import { MESSAGE_TEMPLATE_DELETE, MESSAGE_TEMPLATE_GET, MESSAGE_TEMPLATE_POST, MESSAGE_TEMPLATE_STATUS, MESSAGE_TEMPLATES_LIST_GET_DATA } from "./Constants";

// LOAD
const loadMessageTemplatesList = () => ({
  type: MESSAGE_TEMPLATES_LIST_GET_DATA.MESSAGE_TEMPLATES_LIST_GET_DATA_LOAD,

});

// SUCCESS 
const setMessageTemplatesListSuccess = (data) => ({
  type: MESSAGE_TEMPLATES_LIST_GET_DATA.MESSAGE_TEMPLATES_LIST_GET_DATA_SUCCESS,
  payload: data,
});

// FAIL
const setMessageTemplatesListFail = (error) => ({
  type: MESSAGE_TEMPLATES_LIST_GET_DATA.MESSAGE_TEMPLATES_LIST_GET_DATA_FAIL,
  error,
});

// LOAD
const postMessageTemplate = (request) => ({
  type: MESSAGE_TEMPLATE_POST.MESSAGE_TEMPLATE_POST_LOAD,
  request,
});

// UPDATE
const updateMessageTemplate = (id, request) => ({
  type: MESSAGE_TEMPLATE_POST.MESSAGE_TEMPLATE_UPDATE_LOAD,
  id,
  request,
});

// SUCCESS
const setMessageTemplatePostSuccess = (data) => ({
  type: MESSAGE_TEMPLATE_POST.MESSAGE_TEMPLATE_POST_SUCCESS,
  payload: data,
});

// FAIL
const setMessageTemplatePostFail = (error) => ({
  type: MESSAGE_TEMPLATE_POST.MESSAGE_TEMPLATE_POST_FAIL,
  error,
});

// LOAD
const deleteMessageTemplate = (id) => ({
  type: MESSAGE_TEMPLATE_DELETE.MESSAGE_TEMPLATE_DELETE_LOAD,
  id,
});

// SUCCESS
const deleteMessageTemplateSuccess = (data) => ({
  type: MESSAGE_TEMPLATE_DELETE.MESSAGE_TEMPLATE_DELETE_SUCCESS,
  payload: data,
});

// FAIL
const deleteMessageTemplateFail = (error) => ({
  type: MESSAGE_TEMPLATE_DELETE.MESSAGE_TEMPLATE_DELETE_FAIL,
  error,
});


/* ================= STATUS ================= */

// LOAD
const changeMessageTemplateStatus = (id) => ({
  type: MESSAGE_TEMPLATE_STATUS.MESSAGE_TEMPLATE_STATUS_LOAD,
  id,
});

// SUCCESS
const changeMessageTemplateStatusSuccess = (data) => ({
  type: MESSAGE_TEMPLATE_STATUS.MESSAGE_TEMPLATE_STATUS_SUCCESS,
  payload: data,
});

// FAIL
const changeMessageTemplateStatusFail = (error) => ({
  type: MESSAGE_TEMPLATE_STATUS.MESSAGE_TEMPLATE_STATUS_FAIL,
  error,
});

// LOAD
const getMessageTemplateById = (id) => ({
  type: MESSAGE_TEMPLATE_GET.MESSAGE_TEMPLATE_GET_LOAD,
  id,
});

// SUCCESS
const getMessageTemplateByIdSuccess = (data) => ({
  type: MESSAGE_TEMPLATE_GET.MESSAGE_TEMPLATE_GET_SUCCESS,
  payload: data,
});

// FAIL
const getMessageTemplateByIdFail = (error) => ({
  type: MESSAGE_TEMPLATE_GET.MESSAGE_TEMPLATE_GET_FAIL,
  error,
});

const clearMessageTemplateDetail = () => ({
  type: MESSAGE_TEMPLATE_GET.MESSAGE_TEMPLATE_GET_CLEAR,
});
export {
  loadMessageTemplatesList,
  setMessageTemplatesListSuccess,
  setMessageTemplatesListFail,
  postMessageTemplate,
  setMessageTemplatePostSuccess,
  setMessageTemplatePostFail,
  deleteMessageTemplate,
  deleteMessageTemplateSuccess,
  deleteMessageTemplateFail,
  changeMessageTemplateStatus,
  changeMessageTemplateStatusSuccess,
  changeMessageTemplateStatusFail,
  getMessageTemplateById,
  getMessageTemplateByIdSuccess,
  getMessageTemplateByIdFail,
  clearMessageTemplateDetail,
  updateMessageTemplate
};
